import { Gender } from 'fitbeat.models';
import i18n from './i18n';

export const genders = [{
  display: i18n.t('formFields:male'),
  value: Gender.Male,
}, {
  display: i18n.t('formFields:female'),
  value: Gender.Female,
}, {
  display: i18n.t('formFields:other'),
  value: Gender.Other,
}];
